import { createApp } from 'vue';
import App from './App.vue';

// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'

const app = createApp(App);
app.mount('#app');
